/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { ProductCard } from '@express-labs/raven-ui';
import { cn, getPath } from '@express-labs/raven-tools';
import BagPeekHeader from './subcomponents/BagPeekHeader';
import s from './Bag.module.scss';

export function makeUniqueLineItemKey({
  commerceItemId,
  upc,
  productId,
  color,
  size,
}) {
  return `${commerceItemId}:${upc}:${productId}:${color}:${size}`;
}

function Bag({ bagPeekData }) {
  const lineItems = getPath(bagPeekData, 'lineItems', []);

  return (
    <div className={s.container} aria-label="bagPeek" id="bagPeek">
      <BagPeekHeader
        bagCount={bagPeekData.bagCount}
        subtotal={bagPeekData.subTotal}
      />
      <div className={s.bagItems} id="cartItems">
        {lineItems.length > 0 &&
          lineItems.map((lineItem) => {
            const {
              color,
              listPrice,
              price,
              productId,
              productName,
              productURL,
              promoMessage,
              quantity,
              salePrice,
              size,
            } = lineItem;
            return (
              <ProductCard
                canUseRouter={false}
                className={cn(s.bagItem, 'bagPeekLineItem')} // For PowerFront
                colorClassName='bagPeekProductColor' // For PowerFront
                colorName={color}
                imageClassName='bagPeekProductImage' // For PowerFront
                key={makeUniqueLineItemKey(lineItem)}
                layout="landscape"
                lineItemPrice={price}
                lineItemPriceClassName= 'bagPeekProductTotal' // For PowerFront
                listPrice={listPrice}
                name={productName}
                productId={productId}
                productImage={`https://images.express.com/is/image/expressfashion/${lineItem.upc}?cache=on&wid=361&fmt=jpeg&qlt=75,1&resmode=sharp2&op_usm=1,1,5,0&defaultImage=Photo-Coming-Soon`}
                productLinkTitle={productName}
                productURL={productURL}
                promoMessage={promoMessage}
                quantity={quantity}
                quantityClassName='bagPeekProductQuantity' // For PowerFront
                salePrice={salePrice}
                scale
                sizeClassName='bagPeekProductSize' // For PowerFront
                sizeName={size}
                titleClassName='bagPeekProductLink' // For PowerFront
                unitPriceClassName='bagPeekProductPrice' // For PowerFront
              />
            )
        })}
      </div>
    </div>
  );
}

Bag.propTypes = {
  bagPeekData: PropTypes.shape({
    bagCount: PropTypes.number,
    subTotal: PropTypes.string,
    lineItems: PropTypes.arrayOf(
      PropTypes.shape({
        commerceItemId: PropTypes.string,
        productId: PropTypes.string,
        productName: PropTypes.string,
        price: PropTypes.string,
        size: PropTypes.string,
        color: PropTypes.string,
        upc: PropTypes.string,
        quantity: PropTypes.string,
        productURL: PropTypes.string,
        listPrice: PropTypes.string,
        salePrice: PropTypes.string,
      }),
    ),
  }),
};

export default Bag;
